import React from 'react'
import { Link, Route, Routes } from 'react-router-dom'
import SectionHead from '../components/SectionHead'
import Wrapper from '../helpers/Wrapper'
import Dashboard from './Dashboard'
import Address from './Address'
import AnimatePage from '../components/AnimatePage'
import { ChangePageTitle } from '../helpers/ChangeTitle'


function Account() {

    ChangePageTitle("My Account")

    return (
        <AnimatePage>
            <div className='w-full relative mt-12' initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.8 }}>
                <Wrapper>
                    {/* Head */}
                    <SectionHead
                        title="My Account"
                        description="Manage your orders, track shipments, and update personal details 
                in your account"
                    />

                    {/* main */}
                    <div className="w-full mt-8">
                        <div className="w-full flex flex-col lg:flex-row gap-5">
                            <div className="lg:w-2/12">
                                <div className="bg-containerBg p-5 rounded-lg">
                                    <ul className="flex flex-col gap-4">
                                        <li className='border-b pb-3'>
                                            <Link to="" className=''>Dashboard</Link>
                                        </li>
                                        <li className='border-b pb-3'>
                                            <Link to="address" className=''>Your Address</Link>
                                        </li>
                                        <li className='border-b pb-3'>
                                            <Link to="/wishlist" className=''>Wishlist</Link>
                                        </li>
                                        <li className='border-b pb-3 text-red-600'>
                                            <Link to={'/account/logout'}>Logout</Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            {/* Dashboard and others */}

                            <div className="lg:w-10/12">
                                <Routes>
                                    <Route path='/' element={<Dashboard />} />
                                    <Route path='/address' element={<Address />} />
                                    <Route path='*' element={<div>Page Not Found</div>} />
                                </Routes>
                            </div>

                        </div>
                    </div>
                </Wrapper>
            </div>
        </AnimatePage>
    )
}

export default Account